import { ScenarioDrillFracOverlapBase } from './base/scenario-drill-frac-overlap-base';

export class ScenarioDrillFracOverlap extends ScenarioDrillFracOverlapBase { }